import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
export default {
  name: "membership",
  computed: {
    ...userVuex.mapState(["userInfo", "settingInfo", "isLogin", "userCardInfo"]),
    ...taskVuex.mapState(["taskInfo"]),
    hasMore() {
      const {
        page,
        limit,
        total
      } = this.myPurchaseHistoryPage;
      return page * limit < total;
    }
  },
  data() {
    return {
      cardInfoList: null,
      popBuyCardShow: false,
      selectBuyCardAmount: 1,
      selectCardItem: null,
      isBuyLoading: false,
      popBuyCardCreditsShow: false,
      myPurchaseHistory: null,
      myPurchaseHistoryPage: {
        total: 10,
        page: 1,
        limit: 100,
        loading: false
      },
      popBenefitsShow: false,
      loading: false
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          await this.initFnc();
        }
      },
      deep: true,
      immediate: true
    },
    popBuyCardCreditsShow: {
      handler(bool) {
        if (bool) {
          this.$nextTick(() => {
            this.$refs.scrollList.addEventListener("scroll", this.onScroll);
          });
        }
        if (!bool) {
          this.myPurchaseHistoryPage.page = 1;
          if (this.$refs.scrollList) {
            this.$refs.scrollList.removeEventListener("scroll", this.onScroll);
          }
        }
      }
    }
  },
  methods: {
    ...userVuex.mapActions(["getCardPriceInfo", "buyCard", "getUserRights", "buyCardCredits"]),
    ...userVuex.mapMutations(["setUserInfo"]),
    async initFnc() {
      this.cardInfoList = await this.getCardPriceInfo();
      await this.getBuyCardCredits();
      console.log("this.myPurchaseHistory", this.myPurchaseHistory);
    },
    async getBuyCardCredits(append = false) {
      const params = {
        page: this.myPurchaseHistoryPage.page,
        pageSize: this.myPurchaseHistoryPage.limit
      };
      const history = await this.buyCardCredits(params);
      if (append) {
        this.myPurchaseHistory = [...this.myPurchaseHistory, ...history.items];
      } else {
        this.myPurchaseHistory = history.items;
      }
      this.myPurchaseHistoryPage.total = history.total;
    },
    onCardBuy(item) {
      this.selectCardItem = item;
      this.popBuyCardShow = true;
    },
    async onBuyCard() {
      if (this.isBuyLoading) return;
      this.isBuyLoading = true;
      const res = await this.buyCard({
        priceId: this.selectCardItem.id,
        amount: this.selectBuyCardAmount
      });
      if (!res) {
        this.isBuyLoading = false;
      }
      const rightRes = await this.getUserRights();
      const params = {
        page: 1,
        pageSize: this.myPurchaseHistoryPage.limit
      };
      const history = await this.buyCardCredits(params);
      this.myPurchaseHistory = history.items;
      this.myPurchaseHistoryPage.total = history.total;
      if (!rightRes) {
        this.isBuyLoading = false;
        return;
      }
      this.setUserInfo(res.userInfo);
      this.isBuyLoading = false;
      this.popBuyCardShow = false;
      this.$toasted.clear();
      this.$toasted.success("Purchase Success");
      this.popBuyCardCreditsShow = true;
    },
    onPurchaseHistory() {
      this.popBuyCardCreditsShow = true;
    },
    async onMyPurchaseHistoryChange(page) {
      this.myPurchaseHistoryPage.page = page;
      await this.getBuyCardCredits();
    },
    async onScroll() {
      const el = this.$refs.scrollList;
      if (!el) return;
      const threshold = 50; // 触发加载的距离阈值（单位：px）
      const isBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;
      if (isBottom && !this.loading && this.hasMore) {
        this.loading = true;
        this.myPurchaseHistoryPage.page++;
        await this.getBuyCardCredits(true);
        this.loading = false;
      }
    }
  },
  beforeDestroy() {
    if (this.$refs.scrollList) {
      this.$refs.scrollList.removeEventListener("scroll", this.onScroll);
    }
  }
};